
    <template>
    <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.30408 23.7516C10.4646 24.0697 11.6922 24.2495 12.9667 24.2495C20.1242 24.2495 25.9334 18.8215 25.92 12.1282C25.92 5.42796 20.1175 0 12.96 0C5.80247 0 0 5.42796 0 12.1213C0 15.9036 1.85143 19.2779 4.74931 21.5044L4.42732 25.5425C4.40049 25.8053 4.66881 25.9989 4.9103 25.8882L9.30408 23.7516ZM17.3558 10.5996C17.3558 11.0842 16.9696 11.4824 16.4994 11.4824H13.8293V13.1788H16.4938V13.173C16.964 13.173 17.3502 13.5711 17.3502 14.0558C17.3502 14.5405 16.964 14.9386 16.4938 14.9386H13.8237V17.8755C13.8237 18.3602 13.4374 18.7584 12.9672 18.7584C12.497 18.7584 12.1108 18.3602 12.1108 17.8755V14.9386H9.44071C8.97051 14.9386 8.58427 14.5405 8.58427 14.0558C8.58427 13.5711 8.97051 13.173 9.44071 13.173H12.1108V11.4766H9.44071C8.97051 11.4766 8.58427 11.0785 8.58427 10.5938C8.58427 10.1091 8.97051 9.71099 9.44071 9.71099H11.0696L9.36794 7.95691C9.03768 7.61648 9.03768 7.05102 9.36794 6.71059C9.69821 6.37016 10.2468 6.37016 10.577 6.71059L12.9672 9.18015L15.3574 6.71636C15.6933 6.37593 16.2419 6.37593 16.5721 6.71636C16.9024 7.05679 16.9024 7.62225 16.5721 7.96268L14.8704 9.71676H16.4994C16.9696 9.71676 17.3558 10.1149 17.3558 10.5996Z"
    fill="currentColor"
  />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'OnlineEnquiry',
    }) as DefineComponent
    </script>
    